import styles from './index.module.scss';
import classNames from 'classnames';
import { Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useLoginService } from '../../../services/loginService';
import useMixpanel from '../../../hooks/useMixpanel';

function ForgotPasswordLink() {
  const { state } = useLoginService();
  const { trackClick } = useMixpanel();
  return (
    <Button
      variant="text"
      onClick={() => {
        trackClick('forgot_password');
        state.setForgotPassword({
          value: true,
        });
      }}
      className={classNames(
        styles.forgetButton,
        'text-sm font-semibold self-start leading-5 p-0',
      )}
    >
      Forgot your password?
    </Button>
  );
}
export default observer(ForgotPasswordLink);
